import { memo, useState } from "react";

import { BaseCell } from "../primitives";
import { useCellActions } from "../hooks/useCellActions";

import { FunctionHeader } from "./FunctionCallCell/FunctionHeader";
import { FunctionArguments } from "./FunctionCallCell/FunctionArguments";
import { RawJSONDisplay } from "./FunctionCallCell/RawJSONDisplay";
import { ToolCallItem } from "./FunctionCallCell/ToolCallItem";

import { ReportCell, ReportColumn } from "@/types/evaluate";

interface FunctionCallCellProps {
  cell: ReportCell;
  column?: ReportColumn;
  isColumnSelected?: boolean;
}

export const FunctionCallCell = memo<FunctionCallCellProps>(
  ({ cell, column, isColumnSelected = false }) => {
    const [showRawJSON, setShowRawJSON] = useState(false);

    const { actions } = useCellActions({
      cell,
      column: column!,
      showOpenRequest: false,
    });

    const toggleView = () => {
      setShowRawJSON(!showRawJSON);
    };

    const renderContent = () => {
      if (cell.display_value.type === "function") {
        const functionData = cell.display_value.value;
        return (
          <>
            <FunctionHeader
              name={functionData.name}
              showRawJSON={showRawJSON}
              onToggle={toggleView}
            />
            {showRawJSON ? (
              <RawJSONDisplay data={functionData} />
            ) : (
              <FunctionArguments args={functionData.arguments} />
            )}
          </>
        );
      }

      if (cell.display_value.type === "tool_calls") {
        return (
          <div className="space-y-4">
            {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
            {cell.display_value.value.map((toolCall: any, index: number) => (
              <ToolCallItem
                key={toolCall.id || index}
                toolCall={toolCall}
                showRawJSON={showRawJSON}
                onToggle={toggleView}
                className={index > 0 ? "border-t border-gray-200 pt-4" : ""}
              />
            ))}
          </div>
        );
      }

      return null;
    };

    return (
      <BaseCell isSelected={isColumnSelected} actions={actions}>
        <div className="h-full w-full overflow-hidden">
          <div className="h-full overflow-y-auto p-3">{renderContent()}</div>
        </div>
      </BaseCell>
    );
  },
);
